import React from 'react';
import LabelField from '../Label/LabelField';
import { useTranslation } from 'react-i18next';  // example with react-i18next

const SelectField = ({
  label,
  type = 'text',
  name,
  value,
  onChange,
  error,
  placeholder,
  options = [],
  ...rest
}) => {
  const { t } = useTranslation();
  return (
    <div className="mb-3">
      {label && <LabelField label={label} />}
      <div className="input-group">
        {type === 'select' ? (
          <select
            className={`form-control`}
            name={name}
            value={value}
            onChange={onChange}
            {...rest}
          >
            <option value="">{t('register.selectSector')}</option>
            {options.map((opt, index) => (
              <option key={index} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        ) : (
          <input
            type={type}
            className={`form-control${error ? ' is-invalid' : ''}`}
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            {...rest}
          />
        )}
      </div>
      {error && <div className="invalid-feedback d-block">{error}</div>}
    </div>
  );
};

export default SelectField;
